import React from 'react';
import PropTypes from 'prop-types';

import DsLabel from '../label';
import Btn from './base';

const BtnIcon = (props) => {
  const hasIcon = props.icon || props.iconAfter || props.iconBefore;
  const {
    icon, active, iconBefore, iconAfter, iconClassName, itemClass, children, ...btnProps
  } = props;
  return (
          <Btn {...btnProps}>
            {hasIcon && <DsLabel
                    icon={icon || iconBefore}
                    iconAfter={iconAfter}
                    iconClassName={iconClassName}
                    className={`flex-grow-default ${itemClass || ''}`}
            >
              {children}
            </DsLabel>
            }
            {!hasIcon && children}
          </Btn>
  );
};

BtnIcon.propTypes = {
  icon: PropTypes.string,
};

export default BtnIcon;
